define("powergen/models/size",
  [],
  function() {
    "use strict";
    var Size;

    Size = DS.Model.extend({
      width: DS.attr('number', {
        defaultValue: 0
      }),
      height: DS.attr('number', {
        defaultValue: 0
      })
    });


    return Size;
  });